import { Router } from './lit.js';

export const router = new Router();

router.addRoute('/', 'home');
router.addRoute('/deploy-channels', 'deploy-channels');
router.addRoute('/deploy-channels/new', 'deploy-channels');
router.addRoute('/deploy-channels/:id/edit', 'deploy-channels');
router.addRoute('/alert-channels', 'alert-channels');
router.addRoute('/alert-channels/new', 'alert-channels');
router.addRoute('/alert-channels/:id/edit', 'alert-channels');
router.addRoute('/issue-channels', 'issue-channels');
router.addRoute('/issue-channels/new', 'issue-channels');
router.addRoute('/issue-channels/:id/edit', 'issue-channels');
router.addRoute('/issue-firehose', 'issue-firehose');
router.addRoute('/signups-channel', 'signups-channel');
router.addRoute('/assets-channel', 'assets-channel');
router.addRoute('/social-feed', 'social-feed');
router.addRoute('/issue-broadcast-channels', 'issue-broadcast-channels');
router.addRoute('/issue-broadcast-channels/new', 'issue-broadcast-channels');
router.addRoute('/issue-broadcast-channels/:id/edit', 'issue-broadcast-channels');
router.addRoute('/apps', 'apps');
router.addRoute('/apps/new', 'apps');
router.addRoute('/apps/:id/edit', 'apps');
router.addRoute('/channel-apps', 'channel-apps');
router.addRoute('/channel-apps/new', 'channel-apps');
router.addRoute('/channel-products', 'channel-products');
router.addRoute('/channel-products/new', 'channel-products');
